import React from "react";

// Default plans shown while pricing loads (demo: ₹499 each)
export const DEFAULT_PLANS = [
  {
    id: "monthly",
    label: "Monthly",
    currency: "₹",
    amountRupees: 499,
    period: "/ month",
    savings: "",
    popular: false,
    amountPaise: 49900,
    features: [
      "Ad-free reading experience",
      "Full daily JB ePaper access",
      "Exclusive JB+ articles",
      "All editions unlocked",
    ],
  },
  {
    id: "annual",
    label: "Annual",
    currency: "₹",
    amountRupees: 499,
    period: "/ year",
    savings: "Save ₹389 vs monthly",
    popular: true,
    amountPaise: 49900,
    features: [
      "Ad-free reading experience",
      "Full daily JB ePaper access",
      "Exclusive JB+ articles",
      "All editions unlocked",
      "Priority customer support",
    ],
  },
  {
    id: "quarterly",
    label: "Quarterly",
    currency: "₹",
    amountRupees: 499,
    period: "/ 3 months",
    savings: "Save ₹48 vs monthly",
    popular: false,
    amountPaise: 49900,
    features: [
      "Ad-free reading experience",
      "Full daily JB ePaper access",
      "Exclusive JB+ articles",
      "All editions unlocked",
    ],
  },
];

// Merge live pricing from backend into the plan list
export function mergePricing(plans, pricing) {
  if (!pricing) return plans;
  return plans.map((plan) => {
    const live = pricing[plan.id];
    if (!live) return plan;
    return {
      ...plan,
      amountPaise:  live.amountPaise  ?? plan.amountPaise,
      amountRupees: live.amountPaise  ? Math.round(live.amountPaise / 100) : plan.amountRupees,
      savings:      live.savings      ?? plan.savings,
      period:       live.period       ?? plan.period,
    };
  });
}

function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-IN", { dateStyle: "medium" });
}

export default function PlanCard({ plan, onSelect, loading, selectedId, subscribed = false, expiresAt = null }) {
  const isLoading = loading && selectedId === plan.id;

  return (
    <div className={`plan-card${plan.popular ? " popular" : ""}${subscribed ? " subscribed" : ""}`}>
      {subscribed ? (
        <div className="subscribed-badge">✓ Subscribed</div>
      ) : (
        plan.popular && <div className="popular-badge">⭐ Most Popular</div>
      )}

      <div className="plan-name">{plan.label}</div>

      <div className="plan-price">
        <span className="currency">{plan.currency}</span>
        <span className="amount">{plan.amountRupees}</span>
        <span className="period">{plan.period}</span>
      </div>

      <div className="plan-savings">{plan.savings}</div>

      <hr className="plan-divider" />

      <ul className="plan-features">
        {plan.features.map((f) => (
          <li key={f}>
            <span className="check">✓</span>
            {f}
          </li>
        ))}
      </ul>

      {subscribed && fmtDate(expiresAt) && (
        <div className="plan-active-until">Active until {fmtDate(expiresAt)}</div>
      )}

      <button
        className={`plan-cta ${subscribed ? "subscribed" : plan.popular ? "primary" : "outline"}`}
        onClick={() => onSelect(plan)}
        disabled={isLoading || subscribed}
        aria-label={subscribed ? `${plan.label} plan, subscribed` : `Subscribe to ${plan.label} plan`}
      >
        {isLoading ? <span className="spinner" /> : subscribed ? "✓ Subscribed" : `Get ${plan.label}`}
      </button>
    </div>
  );
}
